import axios from 'axios'

import {
  UPDATE_FOLDER_CHAIN,
  FOLDER_ORDER_UPDATED
} from './types'

import { API_URL } from '../api'
import { cookies } from './index'

export function updateFolderChain(folderChain) {
	return dispatch => {
		dispatch({
			type: UPDATE_FOLDER_CHAIN,
			folderChain: folderChain
		});
	}
}

export function updateFolder(data, type, callback) {
	return dispatch => {
		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: data,
			entityType: type,
		})
		
		if (callback) {
			callback()
		}

		axios.post(API_URL + '/updateItem', { data, type }).catch(error => {
			console.log(error)
		})
	}
}

export function updateFolderOrder(projects, folders){
	return dispatch => {
		axios.post(API_URL + '/updateFolderOrder', { projects }).catch(error => {
			console.log(error)
		})

		dispatch({
			type: FOLDER_ORDER_UPDATED,
			payload: { projects, folders }
		})
	}
}


// WEBPACK FOOTER //
// ./src/state/actions/folder-actions.jsx